import { BackButton } from './components/BackButton';
import { SubmitButton } from './components/SubmitButton';

interface ExperienceButtonPanelProps {
    experienceId: string | undefined;
    validationGroupRef: React.RefObject<any>;
    required?: boolean;
    readOnly?: boolean;
}

export const ExperienceButtonPanel: React.FC<ExperienceButtonPanelProps> = ({ experienceId, validationGroupRef }) => {
    return (
        <>
            <div className='experience-property-buttons'>
                <BackButton experienceId={experienceId} />
                <SubmitButton
                    experienceId={experienceId}
                    validationGroupRef={validationGroupRef}
                />
            </div>
        </>
    );
};
